<template>
  <v-container class="h-100 pa-4" fluid>
    <v-row justify="center" class="h-100">
      <v-sheet class="bg-background flex-1-1 px-4" max-width="420">
        <div class="text-h5 text-center mb-8 font-weight-medium">Reset Password</div>
        <UserPasswordResetComponent
          :is-admin="false"
          :allow-close="false"
          @password-reset-completed="handlePasswordReset">
        </UserPasswordResetComponent>
      </v-sheet>
    </v-row>
  </v-container>
</template>
<script setup lang="ts">
import { useRouter } from 'vue-router';
import { useAuthStore } from '@/stores';
import UserPasswordResetComponent from '@/components/user/UserPasswordResetComponent.vue';
const router = useRouter();
const authStore = useAuthStore();

const handlePasswordReset = async (value: boolean) => {
  if (value) {
    if (authStore.isUser) {
      router.push({ name: 'Home' });
    } else if (authStore.isAdmin) {
      router.push({ name: 'Admin' });
    } else {
      throw 'Something went wrong with resetting your password';
    }
  } else {
    throw 'Something went wrong with resetting your password';
  }
};
</script>
